<template>
    <div>
        <div class="banner">
            <img src="../../assets/img/about/academic/banner.png" alt="" data-aos="zoom-out">
        </div>
        <div class="container">
<!--            <about-menu @aboutSelect="aboutSelect"></about-menu>-->
            <div>
                <div class="personnel">
                    <div class="text" data-aos="fade-up">
                        上海唐颐信息技术有限公司作为精准医学科研服务商，积极参与制定行业标准与行业规范，为生物样本库行业转化与应用提供支持，在推进中国生物样本资源库规范化建设、精准医学大数据共享平台建设的基础上，致力于解码生物医学大数据，促进精准医疗技术产业化，助力健康中国战略的实现。
                    </div>
                    <div class="content">
                        <div class="contentPhoto">
                            <div :class="active===1?'photo active aos-animate':'photo aos-animate'" :data-aos="active===1?'fade-right':'fade-left'" @mouseenter="photoClick(1)">
                                <img src="../../assets/img/about/academic/ll.jpg" alt="">
                                <div class="position" style="right: -40px;text-align: right">CSO</div>
                            </div>
<!--                            <div class="line wow pulse" data-wow-duration="2s"></div>-->
                            <div :class="active===2?'photo active aos-animate':'photo aos-animate'" :data-aos="active===2?'fade-right':'fade-left'" @mouseenter="photoClick(2)" style="margin-left: 100px">
                                <img src="../../assets/img/about/academic/tangwan.png" alt="">
                                <div class="position" style="left: -40px;">CEO</div>
                            </div>
                        </div>
                        <div class="introduce"  v-for="item,index in personnelIntroduce">
                            <div v-show="active===1&index===0">
                                <div class="name">{{item.name}}</div>
                                <div class="position">{{item.position}}</div>
                                <div class="border "></div>
                                <div class="more">
                                    <div v-for="list in item.title">
                                        <span>{{list.association}}</span>
                                        <span>{{list.position}}</span>
                                    </div>
                                </div>
                                <i class="el-icon-caret-bottom triangle" style="left: 140px;"></i>
                            </div>
                            <div v-show="active===2&index===1" style="padding-left: 100px">
                                <div class="more">
                                    <div v-for="list in item.title">
                                        <span>{{list.association}}</span>
                                        <span>{{list.position}}</span>
                                    </div>
                                </div>
                                <div class="border" style="height:150px"></div>
                                <div class="position" style="padding-top:25px">{{item.position}}</div>
                                <div class="name" style="padding-top:30px">{{item.name}}</div>
                                <i class="el-icon-caret-bottom triangle" style="left: 420px;"></i>
                            </div>
                        </div>
                    </div>
                </div>
<!--                <div class="plan">-->
<!--                    <div class="title" data-aos="fade-up">国家重点研发计划</div>-->
<!--                    <div class="tableTitle" data-aos="fade-up">公司首席科学顾问刘雷教授主持与参与的国家重点研发计划包括以下项目</div>-->
<!--                    <table>-->
<!--                        <thead>-->
<!--                            <tr data-aos="fade-up">-->
<!--                                <td>序号</td>-->
<!--                                <td>名称</td>-->
<!--                                <td>项目编号</td>-->
<!--&lt;!&ndash;                                <td>经费</td>&ndash;&gt;-->
<!--                                <td>备注</td>-->
<!--                            </tr>-->
<!--                        </thead>-->
<!--                        <tbody>-->
<!--                            <tr v-for="item in plan" data-aos="fade-up">-->
<!--                                <td>{{item.index}}</td>-->
<!--                                <td v-html="item.name"></td>-->
<!--                                <td v-html="item.number"></td>-->
<!--&lt;!&ndash;                                <td>{{item.money}}</td>&ndash;&gt;-->
<!--                                <td>{{item.remarks}}</td>-->
<!--                            </tr>-->
<!--                        </tbody>-->
<!--                    </table>-->
<!--                </div>-->
                <div class="academic">
                    <div>
                        <div class="title" data-aos="fade-up">学术科研</div>
                        <div class="text" data-aos="fade-up">三库建设、临床数据与样本资源库、干细胞、罕见病</div>
                        <div class="text" data-aos="fade-up">......</div>
                        <div class="operation">
                            <i class="next el-icon-arrow-left" data-aos="fade-right"></i>
                            <i class="prev el-icon-arrow-right" data-aos="fade-left"></i>
                        </div>
                    </div>
                    <div class="swiper">
                        <swiper :options="swiperOption" ref="mySwiper" data-aos="zoom-in">
                            <swiper-slide v-for="item,index in academicList" :key="'academicList'+index" >
                                <div class="text" :style="{height:'54px'}">
                                    <div class="title">{{item.title}}</div>
<!--                                    <div class="content">{{item.content}}</div>-->
                                </div>
                                <img :src="item.src" alt="" style="width: 100%;" :style="{height:'204px'}">
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
                <div class="standard">
                    <div class="title" data-aos="fade-up">行业标准</div>
                    <div class="content">
                        <div class="text" data-aos="fade-up" v-for="item in standardList">{{item}}</div>
                    </div>
                    <div class="pic">
<!--                        <div  data-aos="zoom-in">-->
<!--                            <img  src="../../assets/img/about/academic/standardPic.png" alt="">-->
<!--                        </div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WOW from '../../../node_modules/wowjs/dist/wow';
import AboutMenu from "../../components/AboutMenu";
export default {
    components: {
	    AboutMenu
    },
	data() {
		return {
            active:1,
            personnelIntroduce:[
                {
                    name:'刘雷',
                    position:'公司首席科学顾问',
                    title:[
                        {
                            association:'复旦大学医学院智能医学研究院',
                            position: '--------常务副副院长'
                        },
                        {
                            association:'国际健康科学信息学研究院 (IAHSI)',
                            position: '--------院士'
                        },
                        {
                            association:'国家十三五精准医学专项',
                            position: '--------项目首席'
                        },
                        {
                            association:'中国研究型医院学会临床数据与样本资源库专业委员会',
                            position: '--------副主任委员'
                        },
                        {
                            association:'中华医学会医学信息分会',
                            position: '--------常务委员'
                        },
                        {
                            association:'中国中文信息学会',
                            position: '--------理事'
                        },
                        {
                            association:'全国医药技术市场协会医药健康数据处理专业委员会',
                            position: '--------副主任委员'
                        },
                        {
                            association:'中国医药生物样本库技术协会样本库分会',
                            position: '--------常务委员'
                        },
                        {
                            association:'全国生物样本标准化技术委员会',
                            position: '--------委员'
                        },
                        {
                            association:'中国医药生物技术协会生物医学信息技术分会',
                            position: '--------常务委员'
                        },
                    ]
                },
                {
                    name:'唐万',
                    position:'首席执行官',
                    title:[
                        {
                            association:'曾任:上海生物信息技术研究中心',
                            position: '--------项目总监'
                        },
                        {
                            association:'GB/T 39766‑2021《人类生物样本库管理规范》',
                            position: '--------主要起草人'
                        },
                        {
                            association:'中国研究型医院学会临床数据与样本资源库专业委员会信息学组',
                            position: '--------秘书长'
                        },
                        {
                            association:'中国生物医药技术协会生物样本库分会数据规范与应用学组',
                            position: '--------委员'
                        },
                        {
                            association:'全国生物样本标准化技术委员会',
                            position: '--------委员'
                        },
                        {
                            association:'河北省捐献与移植学会临床样本及再生医学转化研究专业委员会',
                            position: '--------副主任委员'
                        },
                    ]
                }
            ],
            plan:[
                {
                    index:1,
                    name:'国家重点研发计划“精准医学研究”<br>重点专项:疾病研究精准医学知识库构建',
                    number:'项目编号：2016YFC0901900;<br>年度：2016-2020',
                    money:'4632万',
                    remarks:'项目首席'
                },
                {
                    index:2,
                    name:'上海市“地高建”<br>项目:复旦大学上海医学院医学科研数据中心',
                    number:'DGF501010;<br>年度:2020-持续',
                    money:'4632万',
                    remarks:'项目负责人'
                },
                {
                    index:3,
                    name:'国家863数字医疗<br>项目课题:医学知识库与临床决策支持系统',
                    number:'2012AA02A602;<br>2012/01-2015/12',
                    money:'1295万',
                    remarks:'主持'
                },
                {
                    index:4,
                    name:'国家高技术研究发展计划 (863计划)<br>目标导向类项目:建立基于临床医疗信息<br>共享平台的医疗决策支持系统',
                    number:'2006AA02Z344;<br>2006/01-2008/12',
                    money:'480万',
                    remarks:'主持'
                },
                {
                    index:5,
                    name:'传染病国家科技重大专项: 病毒性肝炎相关<br>肝癌样本保藏及相关数据库共享技术平台',
                    number:'2012ZX10002010;<br>2012/01-2015/12',
                    money:'3666万',
                    remarks:'参与'
                },
                {
                    index:6,
                    name:'新药创制国家科技重大专项: 抗艾滋病病毒<br>新药临床评价研究技术平台建设',
                    number:'2012ZX09303013;<br>2012/01-2015/12',
                    money:'1500万',
                    remarks:'参与'
                },
                {
                    index:7,
                    name:'自然科学基金重大项目:“白血病状态下正常<br>造血干/祖细胞的生物学行为及其调控机制”<br>课题',
                    number:'81090410;<br>2011-2014',
                    money:'1000万',
                    remarks:'参与'
                },
                {
                    index:8,
                    name:'国家重点研发计划 :中国重大疾病与罕见病临<br>床与生命组学数据库',
                    number:'2017YFC0908400;<br>2017/07-2020/12',
                    money:'4977万',
                    remarks:'参与'
                },
                {
                    index:9,
                    name:'国家重点研发计划“高性能计算”专项: 基于国家高性能计算环境的生物医药应用服务社区',
                    number:'2016YFB0201700;',
                    money:'',
                    remarks:'参与'
                }
            ],
            swiperOption:{
              navigation: {
                nextEl: ".prev",
                prevEl: ".next",
              },
              slidesPerView: 3,
              autoplay: {
                delay: 2000,
                disableOnInteraction: false,
              },
              direction: "horizontal",
              loop: true,
              centeredSlides: true,
              spaceBetween: 30,
              observer: true,
              observeParents: true,
            },
            academicList:[
                {
                    title:'临床数据与样本资源库专业委员会信息学组成立会议',
                    content:'',
                    src:require('@/assets/img/about/academic/academic1.png')
                },
                {
                    title:'2021三库建设研讨会',
                    content:'',
                    src:require('@/assets/img/about/academic/academic2.png')
                },
                {
                    title:'中国研究型医院学会临床数据与样本资源库专业委员会成立',
                    content:'公司创始人刘雷教授被选举为本届专委会副主任委员上海唐顾信息技术有限公司被选举为专委会委员单位参与信息化标准起草等一系列工作',
                    src:require('@/assets/img/about/academic/academic3.png')
                },
                {
                    title:'2022临床数据与样本资源库专业委员会学术年会',
                    content:'',
                    src:require('@/assets/img/about/academic/academic4.png')
                },
            ],
            standardList:[
                '1、全国生物样本标准化技术委员会归口国家标准 GB/T 39766‑2021《人类生物样本库管理规范》标准起草单位',
                '2、T/CRHA 160‑2025《干细胞临床研究信息管理规范》标准起草单位',
                '3、参与编写生物样本库协会主编的《中国生物样本库-理论与实践》中信息化章节',
                '4、编写301医院郭瑜成院长的《临床样本库》(蓝皮书)信息化章节',
                '5、与解放军总医院、生物样本库协会，共同制订《生物样本库SOP参考》',
                // '6、国家生物标本标准化技术委员会委员中国医疗器械行业协会医用软件分会会员',
                // '7、中国样本资源技术标准委员会信息化标准的主要起草者',
                // '8、参与中国精准医疗标准的起草'
            ],
            standardPic:[
                require('@/assets/img/about/academic/standardPic1.png'),
                require('@/assets/img/about/academic/standardPic2.png'),
                require('@/assets/img/about/academic/standardPic3.png'),
                require('@/assets/img/about/academic/standardPic4.png'),
            ]
        }
	},
	mounted(){
        let wow = new WOW.WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 0,
            mobile: true,
            live: true
        });
        wow.init();
	},
    methods:{
        photoClick(index){
            this.active = index
        },
        aboutSelect(src){
	        this.$emit('aboutSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .banner{
        width: 100%;
    }
    .container{
        width: 100%;
        /*padding-left: 20%;*/
        box-sizing: border-box;
        position: relative;
    }
    .personnel{
        width: 1000px;
        margin: 80px auto;
        .text{
            font-size: 15px;
            line-height: 26px;
            letter-spacing: 1px;
        }
        .content{
            .contentPhoto{
                display: flex;
                align-items: center;
                margin-top: 50px;
                padding: 0 40px;
                .photo{
                    width: 164px;
                    height: 164px;
                    border-radius: 50%;
                    z-index: 2;
                    border: 3px solid #fff;
                    box-shadow: 10px 0px 10px #dad7d7;
                    position: relative;
                    cursor: pointer;
                    img{
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        z-index: 2;
                    }
                    .position{
                        width: 110px;
                        height: 33px;
                        line-height: 33px;
                        color: #fff;
                        font-size: 22px;
                        font-weight: bold;
                        background: #ed1c24;
                        position: absolute;
                        bottom: 10px;
                        border-radius: 20px;
                        box-sizing: border-box;
                        padding: 0 10px;
                        z-index: -1;
                        display: none;
                    }
                }
                .line{
                    width: 540px;
                    height: 1px;
                    background: #ed1c24;
                    z-index: 2;
                }
                .active{
                    width: 228px;
                    height: 228px;
                    border-color: #ed1c24;
                    .position{
                        display: block;
                    }
                }
            }
            .introduce{
                margin-top: 50px;
                position: relative;
                &>div{
                    display: flex;
                    padding: 54px 66px;
                    box-shadow: 0 0 10px #f2eeee;
                    .name{
                        width: 30px;
                        font-size: 29px;
                        text-align: center;
                        margin-right: 30px;
                        line-height: 50px;
                        padding-top:70px;
                        font-weight: bold;
                    }
                    &>.position{
                        width: 20px;
                        font-size: 17px;
                        /*font-weight: bold;*/
                        margin-right: 36px;
                        word-wrap: break-word;
                        word-break: normal;
                    }
                    .border{
                        height: 230px;
                        width: 1px;
                        background: #ed1c24;
                        margin-right: 38px;
                        margin-top: 5px;
                    }
                    .more{
                        div{
                            display: flex;
                            justify-content: space-between;
                            width: 680px;
                            height: 26px;
                            span{
                                font-size: 15px;
                                letter-spacing: 1px;
                            }
                            &>span:nth-child(2){
                                display: inline-block;
                                width: 180px;
                            }
                        }

                    }
                    .triangle{
                        position: absolute;
                        color: #ed1c24;
                        top: -15px;
                        font-size: 40px;
                    }
                }

            }
        }
    }
    .plan{
        width: 100%;
        .title{
            width: 391px;
            height: 60px;
            background: url("../../assets/img/about/academic/planTitle.png") no-repeat;
            margin: 0 auto;
            font-size: 27px;
            line-height: 27px;
            color: #ed1c24;
            letter-spacing: 6px;
            text-align: center;
        }
        .tableTitle{
            width: 981px;
            height: 46px;
            line-height: 46px;
            text-align: center;
            background: #fff0f0;
            font-size: 19px;
            letter-spacing: 2px;
            color: #ed1c24;
            margin: 47px auto 0;
        }
        table{
            width: 981px;
            margin: 0 auto;
            thead{
                td{
                    text-align: center;
                    line-height: 46px;
                    background: #f3f3f3;
                }
            }
            tbody{
                td{
                    padding: 5px 20px 5px 20px;
                    background: #f3f3f3;
                    line-height: 25px;
                    font-size: 15px;
                    text-align: center;
                }
                td:nth-child(1){
                     width: 105px;
                     box-sizing: border-box;
                }
                td:nth-child(2){
                     width: 326px;
                     box-sizing: border-box;
                }
                td:nth-child(3){
                     width: 260px;
                     box-sizing: border-box;
                }
                td:nth-child(2),td:nth-child(3){
                    text-align: left;
                    padding-right: 0;
                }
            }
        }
    }
    .academic{
        width: 100%;
        margin-top: 100px;
        position: relative;
        &>div:nth-child(1){
            width: 100%;
            height: 832px;
            margin: 0 auto;
            background-image: linear-gradient(to bottom left, #97d9ff, #006efd);
            padding-top: 78px;
            box-sizing: border-box;
            border-radius: 10px;
           .title{
                width: 291px;
                height: 60px;
                background: url("../../assets/img/about/academic/academicTitle.png") no-repeat;
                font-size: 28px;
                line-height: 28px;
                color: #ed1c24;
                letter-spacing: 6px;
                margin: 0 auto 80px;
                text-align: center;
            }
            .text{
                font-size: 15px;
                color: #fff;
                line-height: 35px;
                text-align: center;
            }
            .operation{
                margin-top: 430px;
                display: flex;
                justify-content: space-between;
                width: 100%;
                box-sizing: border-box;
                padding: 0 84px;
                i{
                    color: #fff;
                    font-size: 50px;
                }
            }
        }
        .swiper{
            position: absolute;
            left: 0;
            top: 304px;
            width: 100%;
            /deep/
            .swiper-wrapper{
                /*transform: translate3d(-323px, 0px, 0px)!important;*/
                .swiper-slide{
                    width: 568px;
                    height: 332px;
                    background: #fff;
                    border-radius: 10px;
                    padding: 38px 47px;
                    box-sizing: border-box;
                    .text{
                        height: 54px;
                        margin-bottom: 10px;
                        .title{
                            font-size: 18px;
                            box-sizing: border-box;
                            letter-spacing: 1px;
                        }
                        .content{
                            font-size: 15px;
                            box-sizing: border-box;
                            letter-spacing: 1px;
                        }
                    }
                    img{
                        height: 204px;
                    }

                }
            }

        }
    }
    .standard{
        margin-top: 75px;
        .title{
            width: 308px;
            height: 61px;
            background: url("../../assets/img/about/academic/standardTitle.png") no-repeat;
            font-size: 27px;
            line-height: 27px;
            margin: 0 auto;
            text-align: center;
            color: #ed1c24;
            letter-spacing: 2px;
        }
        .content{
            margin-top: 70px;
            .text{
                width: 888px;
                margin: 0 auto;
                font-size: 14px;
                line-height: 30px;
                letter-spacing: 2px;
            }
        }
        .pic{
            margin: 60px auto;
            width: 961px;
            display: flex;
            justify-content: space-between;
            div{
                padding: 5px;
                background: #fff;
                /*box-shadow: 0 0 10px #dedede;*/
                img{
                    /*height: 253px;*/
                }
            }
        }
    }
</style>
